import ContactForm from '../components/ContactForm';

function Contact() {
  return (
    <div className="contact-page">
      <ContactForm />
    </div>
  );
}

export default Contact;
